import React from 'react';
import { motion } from 'framer-motion';
import './ProgressIndicator.css';

const ProgressIndicator = ({ 
  currentPillar, 
  totalQuestions, 
  answeredQuestions, 
  completionPercentage 
}) => {
  const pillars = [
    { name: 'LEAD', color: '#667eea' },
    { name: 'EVOLVE', color: '#764ba2' },
    { name: 'ALIGN', color: '#f093fb' },
    { name: 'PERFORM', color: '#4facfe' }
  ];

  return (
    <div className="progress-indicator">
      <div className="progress-stats">
        <div className="progress-stat">
          <span className="stat-value">{answeredQuestions}</span>
          <span className="stat-label">/ {totalQuestions} Answered</span>
        </div>
        <div className="progress-stat">
          <span className="stat-value">{completionPercentage}%</span>
          <span className="stat-label">Complete</span>
        </div>
      </div>

      <div className="progress-bar-container">
        <motion.div
          className="progress-bar"
          initial={{ width: 0 }}
          animate={{ width: `${completionPercentage}%` }}
          transition={{ duration: 0.5 }}
        />
      </div>

      <div className="progress-pillars">
        {pillars.map((pillar, index) => (
          <div
            key={pillar.name}
            className={`progress-pillar ${currentPillar === pillar.name ? 'active' : ''}`}
            style={{ 
              borderColor: currentPillar === pillar.name ? pillar.color : 'rgba(255,255,255,0.2)'
            }}
          >
            <div
              className="pillar-indicator"
              style={{ 
                background: currentPillar === pillar.name ? pillar.color : 'transparent'
              }}
            />
            <span style={{ color: currentPillar === pillar.name ? pillar.color : '#888' }}>
              {pillar.name}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProgressIndicator;
